const locale = {
  placeholder: 'Selecteer tijd',
};

export default locale;
